var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGgConnectLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 383",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3943_50181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.901 343.54H416.781V343.79H449.901V343.54Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.221 348.26H322.531V348.51H331.221V348.26Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.78 334.26H396.59V334.51H415.78V334.26Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6509 335.94H52.4609V336.19H95.6509V335.94Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.889 335.94H104.559V336.19H110.889V335.94Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.149 340.16H131.469V340.41H225.149V340.16Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.009 282.85H43.9092C40.7592 282.85 38.1992 280.29 38.1992 277.14V5.71C38.1992 2.56 40.7592 0 43.9092 0H237.009C240.159 0 242.719 2.56 242.719 5.71V277.14C242.719 280.29 240.159 282.85 237.009 282.85ZM43.9092 0.25C40.8992 0.25 38.4492 2.7 38.4492 5.71V277.14C38.4492 280.15 40.8992 282.6 43.9092 282.6H237.009C240.019 282.6 242.469 280.15 242.469 277.14V5.71C242.469 2.7 240.019 0.25 237.009 0.25H43.9092Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31 282.85H260.21C257.06 282.85 254.5 280.29 254.5 277.14V5.71C254.5 2.56 257.06 0 260.21 0H453.31C456.46 0 459.02 2.56 459.02 5.71V277.14C459.02 280.29 456.46 282.85 453.31 282.85ZM260.21 0.25C257.2 0.25 254.75 2.7 254.75 5.71V277.14C254.75 280.15 257.2 282.6 260.21 282.6H453.31C456.32 282.6 458.77 280.15 458.77 277.14V5.71C458.77 2.7 456.32 0.25 453.31 0.25H260.21Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 327.45H0V327.7H500V327.45Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.753 209.46H266.453L267.493 199.28H417.793L416.753 209.46Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.133 209.46H251.562L252.603 199.28H393.173L392.133 209.46Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.432 213.24H250.762L252.582 195.31H420.252L418.432 213.24ZM251.722 211.18H417.892L419.302 197.37H253.132L251.722 211.18Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.15 208.46H252.91L253.77 200.28H258.01L257.15 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.31 208.46H258.07L258.93 200.28H263.17L262.31 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.47 208.46H263.23L264.09 200.28H268.33L267.47 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.631 208.46H268.391L269.251 200.28H273.491L272.631 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.791 208.46H273.551L274.411 200.28H278.651L277.791 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.951 208.46H278.711L279.571 200.28H283.811L282.951 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.111 208.46H283.871L284.731 200.28H288.971L288.111 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.271 208.46H289.031L289.891 200.28H294.131L293.271 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.431 208.46H294.191L295.051 200.28H299.291L298.431 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.592 208.46H299.352L300.212 200.28H304.452L303.592 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.752 208.46H304.512L305.372 200.28H309.602L308.752 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.912 208.46H309.672L310.532 200.28H314.762L313.912 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.062 208.46H314.832L315.692 200.28H319.922L319.062 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.218 208.46H319.988L320.848 200.28H325.078L324.218 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.378 208.46H325.148L326.008 200.28H330.238L329.378 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.539 208.46H330.309L331.169 200.28H335.399L334.539 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.699 208.46H335.469L336.329 200.28H340.559L339.699 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.859 208.46H340.629L341.489 200.28H345.719L344.859 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.019 208.46H345.789L346.649 200.28H350.879L350.019 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.179 208.46H350.949L351.799 200.28H356.039L355.179 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.339 208.46H356.109L356.959 200.28H361.199L360.339 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.502 208.46H361.262L362.122 200.28H366.362L365.502 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.662 208.46H366.422L367.282 200.28H371.522L370.662 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.822 208.46H371.582L372.442 200.28H376.682L375.822 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.978 208.46H376.738L377.598 200.28H381.838L380.978 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.138 208.46H381.898L382.758 200.28H386.998L386.138 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.299 208.46H387.059L387.919 200.28H392.159L391.299 208.46Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.033 212.91H422.723L424.143 196.6H428.803L428.683 197.98H425.413L424.233 211.52H437.763L438.953 197.98H435.603L435.733 196.6H440.453L439.033 212.91Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.285 204.75H430.895L432.265 189.16H433.645L432.285 204.75Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.953 192.52L432.863 189.95L428.163 192.28L427.633 191.05L433.043 188.37L437.763 191.33L436.953 192.52Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.72 164.02H279.43L280.46 153.83H430.76L429.72 164.02Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.581 164.02H264.531L265.571 153.83H416.621L415.581 164.02Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.4 167.79H263.73L265.55 149.86H433.22L431.4 167.79ZM264.69 165.73H430.86L432.27 151.92H266.1L264.69 165.73Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.121 163.02H265.891L266.741 154.83H270.981L270.121 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.281 163.02H271.051L271.901 154.83H276.141L275.281 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.439 163.02H276.199L277.059 154.83H281.299L280.439 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.599 163.02H281.359L282.219 154.83H286.459L285.599 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.76 163.02H286.52L287.38 154.83H291.62L290.76 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92 163.02H291.68L292.54 154.83H296.78L295.92 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08 163.02H296.84L297.7 154.83H301.94L301.08 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24 163.02H302L302.86 154.83H307.1L306.24 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.4 163.02H307.16L308.02 154.83H312.26L311.4 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.56 163.02H312.32L313.18 154.83H317.42L316.56 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.72 163.02H317.48L318.34 154.83H322.58L321.72 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.881 163.02H322.641L323.501 154.83H327.741L326.881 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.041 163.02H327.801L328.661 154.83H332.901L332.041 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.201 163.02H332.961L333.821 154.83H338.061L337.201 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.361 163.02H338.121L338.981 154.83H343.211L342.361 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.521 163.02H343.281L344.141 154.83H348.371L347.521 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.671 163.02H348.441L349.301 154.83H353.531L352.671 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.832 163.02H353.602L354.462 154.83H358.692L357.832 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.992 163.02H358.762L359.622 154.83H363.852L362.992 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.152 163.02H363.922L364.782 154.83H369.012L368.152 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.312 163.02H369.082L369.942 154.83H374.172L373.312 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.472 163.02H374.242L375.102 154.83H379.332L378.472 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.632 163.02H379.402L380.262 154.83H384.492L383.632 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.793 163.02H384.562L385.413 154.83H389.652L388.793 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.949 163.02H389.719L390.569 154.83H394.809L393.949 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.109 163.02H394.879L395.729 154.83H399.969L399.109 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.271 163.02H400.031L400.891 154.83H405.131L404.271 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.431 163.02H405.191L406.051 154.83H410.291L409.431 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.592 163.02H410.352L411.212 154.83H415.452L414.592 163.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.919 167.55H435.609L437.029 151.24H441.689L441.569 152.63H438.299L437.109 166.16H450.649L451.839 152.63H448.489L448.609 151.24H453.339L451.919 167.55Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.191 159.39H443.801L445.171 143.8H446.551L445.191 159.39Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.45 160.19L439.5 157.51L440.25 156.28L444.54 158.6L449.09 156.04L449.69 157.23L444.45 160.19Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6981 129L69.5781 130.37H192.298L192.418 129H69.6981Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.418 129H69.6981L69.5781 130.37H192.298L192.418 129Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.789 113.39H71.2188L78.6188 28.73H201.199L193.789 113.39Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5781 146.77C71.1081 146.77 68.5481 143.96 68.8481 140.49C69.1481 137.02 72.2081 134.21 75.6781 134.21C79.1481 134.21 81.7081 137.02 81.4081 140.49C81.1081 143.96 78.0481 146.77 74.5781 146.77Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.589 123.8H70.3086L70.7786 118.38H132.069L131.589 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.11 143.19H167.43L167.9 137.78H191.58L191.11 143.19Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.879 123.8H187.469L187.939 118.38H193.349L192.879 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.707 123.8H178.297L178.767 118.38H184.177L183.707 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.537 123.8H169.117L169.597 118.38H175.007L174.537 123.8Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M201.649 23.5199H109.719L110.129 18.8599H202.059L201.649 23.5199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.457 23.89H78.7773L79.2573 18.48H102.937L102.457 23.89Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.609 107.25L86.1094 108.88L86.3394 106.34H189.169L184.609 107.25Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.268 108.88H75.918L76.138 106.34H179.488L179.268 108.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.279 109.82H75.5586L75.9486 105.35H190.669L190.279 109.82ZM76.1186 109.3H189.809L190.109 105.86H76.4186L76.1186 109.3Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.999 382.61C357.082 382.61 443.889 377.542 443.889 371.29C443.889 365.038 357.082 359.97 249.999 359.97C142.917 359.97 56.1094 365.038 56.1094 371.29C56.1094 377.542 142.917 382.61 249.999 382.61Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.581 334.96C403.581 334.96 396.551 319.63 404.581 304.52C412.611 289.41 414.931 285.85 409.821 282.75C404.701 279.65 402.351 294.84 402.351 294.84C402.351 294.84 398.041 284.39 401.601 273.46C405.161 262.53 407.401 244.72 402.531 242.81C397.671 240.9 401.601 265.02 397.381 273.25C397.381 273.25 393.831 264.1 393.251 255.31C392.671 246.52 393.581 232.51 389.741 228.91C385.901 225.31 383.441 227.8 387.211 247.18C390.981 266.56 390.961 282.31 390.961 282.31C390.961 282.31 382.621 256.89 377.031 256.15C371.431 255.41 371.441 263.64 376.231 270.78C381.021 277.92 390.261 290.71 391.771 297.29C391.771 297.29 382.621 278.16 374.391 284.02C366.161 289.88 381.561 301.44 388.421 305.61C395.281 309.79 400.051 335.96 400.051 335.96L403.591 334.95L403.581 334.96Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M403.581 334.96C403.581 334.96 396.551 319.63 404.581 304.52C412.611 289.41 414.931 285.85 409.821 282.75C404.701 279.65 402.351 294.84 402.351 294.84C402.351 294.84 398.041 284.39 401.601 273.46C405.161 262.53 407.401 244.72 402.531 242.81C397.671 240.9 401.601 265.02 397.381 273.25C397.381 273.25 393.831 264.1 393.251 255.31C392.671 246.52 393.581 232.51 389.741 228.91C385.901 225.31 383.441 227.8 387.211 247.18C390.981 266.56 390.961 282.31 390.961 282.31C390.961 282.31 382.621 256.89 377.031 256.15C371.431 255.41 371.441 263.64 376.231 270.78C381.021 277.92 390.261 290.71 391.771 297.29C391.771 297.29 382.621 278.16 374.391 284.02C366.161 289.88 381.561 301.44 388.421 305.61C395.281 309.79 400.051 335.96 400.051 335.96L403.591 334.95L403.581 334.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.032 341.25C398.032 341.25 404.872 325.82 396.662 310.83C388.452 295.84 386.082 292.31 391.162 289.14C396.242 285.97 398.772 301.12 398.772 301.12C398.772 301.12 402.962 290.61 399.272 279.73C395.582 268.85 393.132 251.08 397.972 249.1C402.812 247.12 399.172 271.3 403.482 279.46C403.482 279.46 406.912 270.25 407.392 261.46C407.872 252.67 406.792 238.66 410.592 235.01C414.392 231.36 416.882 233.81 413.342 253.24C409.802 272.67 410.012 288.42 410.012 288.42C410.012 288.42 418.042 262.88 423.632 262.05C429.222 261.23 429.312 269.46 424.602 276.67C419.902 283.88 410.812 296.81 409.382 303.41C409.382 303.41 418.302 284.15 426.602 289.89C434.902 295.63 419.642 307.41 412.832 311.69C406.022 315.97 401.572 342.21 401.572 342.21L398.022 341.25H398.032Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.59 330.25H373.07L377.64 370.69H425.01L429.59 330.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.197 137.79L288.417 113.81H286.997L277.137 137.79H279.197Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.708 137.92L294.228 120.66L293.108 120.41L281.078 137.55L282.708 137.92Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.007 137.73L229.797 113.75H231.217L241.077 137.73H239.007Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.508 137.85L223.988 120.6L225.108 120.35L237.128 137.49L235.508 137.85Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.887 135.1H258.867L259.407 107.85H260.347L260.887 135.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.387 137.73L239.857 138.8H241.227L240.787 137.73H239.387Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.848 137.73L278.378 138.8H277.008L277.438 137.73H278.848Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.879 137.79L236.529 139.01H237.879L236.709 137.58L235.879 137.79Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.369 137.79L281.719 139.01H280.379L281.539 137.58L282.369 137.79Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.148 135.1L259.158 137.29H260.598V135.1H259.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.708 145.07H237.008V148.62H242.708V145.07Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.368 145.07H275.668V148.62H281.368V145.07Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.369 146.64L270.979 147.98C263.119 148.83 255.199 148.83 247.339 147.98L234.949 146.64V138.95L245.009 137.64C254.399 136.42 263.909 136.42 273.299 137.64L283.359 138.95V146.64H283.369Z",
    fill: "#8D86C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.15 143.02C242.15 144.29 241.12 145.31 239.86 145.31C238.6 145.31 237.57 144.28 237.57 143.02C237.57 141.76 238.6 140.73 239.86 140.73C241.12 140.73 242.15 141.76 242.15 143.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.232 143.03C241.232 143.79 240.622 144.4 239.862 144.4C239.102 144.4 238.492 143.79 238.492 143.03C238.492 142.27 239.102 141.66 239.862 141.66C240.622 141.66 241.232 142.27 241.232 143.03Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.851 143.03C252.851 143.43 252.531 143.76 252.121 143.76C251.711 143.76 251.391 143.44 251.391 143.03C251.391 142.62 251.711 142.3 252.121 142.3C252.531 142.3 252.851 142.62 252.851 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.429 143.03C255.429 143.43 255.099 143.76 254.699 143.76C254.299 143.76 253.969 143.44 253.969 143.03C253.969 142.62 254.289 142.3 254.699 142.3C255.109 142.3 255.429 142.62 255.429 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.022 143.03C258.022 143.43 257.703 143.76 257.293 143.76C256.883 143.76 256.562 143.44 256.562 143.03C256.562 142.62 256.883 142.3 257.293 142.3C257.703 142.3 258.022 142.62 258.022 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.601 143.03C260.601 143.43 260.281 143.76 259.871 143.76C259.461 143.76 259.141 143.44 259.141 143.03C259.141 142.62 259.461 142.3 259.871 142.3C260.281 142.3 260.601 142.62 260.601 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.19 143.03C263.19 143.43 262.87 143.76 262.46 143.76C262.05 143.76 261.73 143.44 261.73 143.03C261.73 142.62 262.05 142.3 262.46 142.3C262.87 142.3 263.19 142.62 263.19 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.78 143.03C265.78 143.43 265.46 143.76 265.05 143.76C264.64 143.76 264.32 143.44 264.32 143.03C264.32 142.62 264.64 142.3 265.05 142.3C265.46 142.3 265.78 142.62 265.78 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.362 143.03C268.362 143.43 268.042 143.76 267.632 143.76C267.222 143.76 266.902 143.44 266.902 143.03C266.902 142.62 267.222 142.3 267.632 142.3C268.042 142.3 268.362 142.62 268.362 143.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.252 222H219.202L218.692 219.62C216.352 213.32 204.342 213.32 204.342 213.32C201.372 213.49 198.462 216.27 197.632 220.17L197.242 222.01L197.252 222Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.19 195.42H160.16L162.79 218.48H184.85L180.2 195.42H180.19Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.739 221.41H187.699V221.67H150.289V218.48H184.849L180.199 195.42H160.169L159.059 185.64C159.119 184.31 160.229 183.25 161.559 183.25H178.719C180.059 183.25 181.159 184.3 181.229 185.64L188.739 221.41Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.85 218.48H162.79L160.37 197.23L160.16 195.42H180.19L184.85 218.48Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.09 203.1L160.16 195.42H183.28L184.89 203.1H161.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.979 219.15H124.359C124.079 219.15 123.859 218.95 123.859 218.69V216.16C123.859 215.91 124.079 215.7 124.359 215.7H126.239C126.469 215.7 126.659 215.84 126.719 216.04L127.459 218.57C127.539 218.86 127.309 219.14 126.979 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 219.15H127.98C127.7 219.15 127.48 218.95 127.48 218.69V216.16C127.48 215.91 127.7 215.7 127.98 215.7H129.86C130.09 215.7 130.28 215.84 130.34 216.04L131.08 218.57C131.16 218.86 130.93 219.14 130.6 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.218 219.15H131.598C131.318 219.15 131.098 218.95 131.098 218.69V216.16C131.098 215.91 131.318 215.7 131.598 215.7H133.478C133.708 215.7 133.898 215.84 133.958 216.04L134.698 218.57C134.778 218.86 134.548 219.14 134.218 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.839 219.15H135.219C134.939 219.15 134.719 218.95 134.719 218.69V216.16C134.719 215.91 134.939 215.7 135.219 215.7H137.099C137.329 215.7 137.519 215.84 137.579 216.04L138.319 218.57C138.399 218.86 138.169 219.14 137.839 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.448 219.15H138.828C138.548 219.15 138.328 218.95 138.328 218.69V216.16C138.328 215.91 138.548 215.7 138.828 215.7H140.708C140.938 215.7 141.128 215.84 141.188 216.04L141.928 218.57C142.008 218.86 141.778 219.14 141.448 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.069 219.15H142.449C142.169 219.15 141.949 218.95 141.949 218.69V216.16C141.949 215.91 142.169 215.7 142.449 215.7H144.329C144.559 215.7 144.749 215.84 144.809 216.04L145.549 218.57C145.629 218.86 145.399 219.14 145.069 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69 219.15H146.07C145.79 219.15 145.57 218.95 145.57 218.69V216.16C145.57 215.91 145.79 215.7 146.07 215.7H147.95C148.18 215.7 148.37 215.84 148.43 216.04L149.17 218.57C149.25 218.86 149.02 219.14 148.69 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.307 219.15H149.688C149.407 219.15 149.188 218.95 149.188 218.69V216.16C149.188 215.91 149.407 215.7 149.688 215.7H151.568C151.798 215.7 151.988 215.84 152.048 216.04L152.787 218.57C152.867 218.86 152.637 219.14 152.307 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.929 219.15H153.309C153.029 219.15 152.809 218.95 152.809 218.69V216.16C152.809 215.91 153.029 215.7 153.309 215.7H155.189C155.419 215.7 155.609 215.84 155.669 216.04L156.409 218.57C156.489 218.86 156.259 219.14 155.929 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55 219.15H156.93C156.65 219.15 156.43 218.95 156.43 218.69V216.16C156.43 215.91 156.65 215.7 156.93 215.7H158.81C159.04 215.7 159.23 215.84 159.29 216.04L160.03 218.57C160.11 218.86 159.88 219.14 159.55 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.171 219.15H160.551C160.271 219.15 160.051 218.95 160.051 218.69V216.16C160.051 215.91 160.271 215.7 160.551 215.7H162.431C162.661 215.7 162.851 215.84 162.911 216.04L163.651 218.57C163.731 218.86 163.501 219.14 163.171 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.788 219.15H164.168C163.888 219.15 163.668 218.95 163.668 218.69V216.16C163.668 215.91 163.888 215.7 164.168 215.7H166.048C166.278 215.7 166.468 215.84 166.528 216.04L167.268 218.57C167.348 218.86 167.118 219.14 166.788 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.409 219.15H167.789C167.509 219.15 167.289 218.95 167.289 218.69V216.16C167.289 215.91 167.509 215.7 167.789 215.7H169.669C169.899 215.7 170.089 215.84 170.149 216.04L170.889 218.57C170.969 218.86 170.739 219.14 170.409 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.03 219.15H171.41C171.13 219.15 170.91 218.95 170.91 218.69V216.16C170.91 215.91 171.13 215.7 171.41 215.7H173.29C173.52 215.7 173.71 215.84 173.77 216.04L174.51 218.57C174.59 218.86 174.36 219.14 174.03 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 219.15H175.031C174.751 219.15 174.531 218.95 174.531 218.69V216.16C174.531 215.91 174.751 215.7 175.031 215.7H176.911C177.141 215.7 177.331 215.84 177.391 216.04L178.131 218.57C178.211 218.86 177.981 219.14 177.651 219.14V219.15Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.29 219.43C180.29 220.53 179.31 221.42 178.11 221.42H123.91C122.7 221.42 121.73 220.53 121.73 219.43C121.73 218.88 121.97 218.38 122.36 218.02C122.74 217.67 123.27 217.45 123.85 217.44H178.1C178.31 217.44 178.51 217.47 178.7 217.52C179.61 217.76 180.28 218.52 180.28 219.43H180.29Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.29 219.43C180.29 220.53 179.31 221.42 178.11 221.42H123.91C122.7 221.42 121.73 220.53 121.73 219.43C121.73 218.88 121.97 218.38 122.36 218.02C122.74 217.67 123.27 217.45 123.85 217.44H178.1C178.31 217.44 178.51 217.47 178.7 217.52C179.61 217.76 180.28 218.52 180.28 219.43H180.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.29 219.43C180.29 220.53 179.31 221.42 178.11 221.42H159.76C158.88 221.16 158.25 220.41 158.25 219.52C158.25 219.39 158.26 219.28 158.28 219.16C158.36 218.75 158.58 218.39 158.89 218.11C159.03 217.98 159.19 217.88 159.36 217.78C159.44 217.74 159.53 217.7 159.61 217.66C159.87 217.56 160.15 217.52 160.45 217.52H178.72C179.63 217.76 180.3 218.52 180.3 219.43H180.29Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.733 130.65H213.193L206.973 198.2H212.513C213.433 198.2 214.253 197.34 214.353 196.28L220.223 132.57C220.323 131.51 219.653 130.65 218.743 130.65H218.733Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.162 198.2H127.162C126.242 198.2 125.582 197.34 125.682 196.28L131.552 132.57C131.652 131.51 132.472 130.65 133.392 130.65H216.392C217.312 130.65 217.972 131.51 217.872 132.57L212.002 196.28C211.902 197.34 211.082 198.2 210.162 198.2Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.162 198.2H127.162C126.242 198.2 125.582 197.34 125.682 196.28L131.552 132.57C131.652 131.51 132.472 130.65 133.392 130.65H216.392C217.312 130.65 217.972 131.51 217.872 132.57L212.002 196.28C211.902 197.34 211.082 198.2 210.162 198.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.663 184.64H132.273L136.453 136.86H211.843L207.663 184.64Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.622 188.39H132.332C130.222 188.39 128.662 186.68 128.852 184.57L133.002 137.08C133.182 134.97 135.042 133.26 137.152 133.26H211.442C213.552 133.26 215.112 134.97 214.922 137.08L210.772 184.57C210.592 186.68 208.732 188.39 206.622 188.39Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.663 184.64H132.273L136.453 136.86H211.843L207.663 184.64Z",
    fill: "#F4F4FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M207.39 184.78H132L136.18 137H211.57L207.39 184.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.86 165.87H164.32L165.16 156.33H167.88L167.81 157.14H165.9L165.21 165.06H173.12L173.82 157.14H171.86L171.93 156.33H174.7L173.86 165.87Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.931 161.1H169.121L169.921 151.98H170.731L169.931 161.1Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.502 161.56L166.602 160L167.042 159.28L169.552 160.64L172.212 159.14L172.562 159.83L169.502 161.56Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.981 166.31H149.441L150.271 156.77H152.991L152.921 157.58H151.011L150.321 165.5H158.241L158.931 157.58H156.971L157.051 156.77H159.811L158.981 166.31Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.033 161.54H154.223L155.023 152.42H155.833L155.033 161.54Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.762 154.39L155.372 152.89L152.622 154.25L152.312 153.53L155.482 151.96L158.243 153.69L157.762 154.39Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.39 133.29L168.66 188.36H173.61L188.18 133.29H183.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.029 133.29L176.309 188.36H186.129L200.689 133.29H191.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.379 233.18H150.039L160.709 359.52C160.829 360.93 159.719 362.14 158.299 362.14C157.059 362.14 156.019 361.2 155.899 359.96L143.379 233.18Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.488 232.3H310.148L320.818 359.52C320.938 360.93 319.828 362.14 318.408 362.14C317.168 362.14 316.128 361.2 316.008 359.96L303.488 232.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.169 232.3H109.449V254.71H308.169V232.3Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.258 232.47L272.488 254.69L308.168 254.71V232.3L273.258 232.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.239 232.47H109.469V254.88H270.239V232.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83 232.3H107.17L106.98 368.16C106.98 369.5 108.06 370.58 109.4 370.58C110.72 370.58 111.8 369.52 111.82 368.19L113.84 232.29L113.83 232.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94 232.3H267.28L267.09 368.16C267.09 369.5 268.17 370.58 269.51 370.58C270.83 370.58 271.91 369.52 271.93 368.19L273.95 232.29L273.94 232.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.17 232.3L106.98 368.16C106.98 369.5 108.06 370.58 109.4 370.58C110.72 370.58 111.8 369.52 111.82 368.19L113.84 232.29H107.18L107.17 232.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.94 232.3H267.28L267.09 368.16C267.09 369.5 268.17 370.58 269.51 370.58C270.83 370.58 271.91 369.52 271.93 368.19L273.95 232.29L273.94 232.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.629 226.91C101.629 223.89 102.759 221.45 104.139 221.44H313.179C314.559 221.44 315.689 223.89 315.689 226.91C315.689 229.93 314.559 232.37 313.179 232.38H104.139C102.759 232.38 101.629 229.93 101.629 226.91Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.629 226.91C101.629 223.89 102.759 221.45 104.139 221.44H313.179C314.559 221.44 315.689 223.89 315.689 226.91C315.689 229.93 314.559 232.37 313.179 232.38H104.139C102.759 232.38 101.629 229.93 101.629 226.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.73 226.91C261.73 223.89 262.86 221.45 264.24 221.44H313.18C314.56 221.44 315.69 223.89 315.69 226.91C315.69 229.93 314.56 232.37 313.18 232.38H264.24C262.86 232.38 261.73 229.93 261.73 226.91Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.987 212.65C197.047 212.65 190.847 198.16 190.777 197.98L192.027 197.46C192.347 198.24 200.157 216.39 221.707 209.91C243.547 203.34 260.917 156.84 261.097 156.37L262.367 156.84C261.647 158.78 244.587 204.45 222.097 211.21C218.757 212.21 215.727 212.64 212.987 212.64V212.65Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.059 148.46H255.109V221.99H287.059V148.46Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M287.059 148.46H255.109V221.99H287.059V148.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.208 148.46H232.258V221.99H264.208V148.46Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.997 164.15C253.997 167.76 251.067 170.68 247.467 170.68C243.867 170.68 240.938 167.75 240.938 164.15C240.938 160.55 243.867 157.62 247.467 157.62C251.067 157.62 253.997 160.55 253.997 164.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.379 164.2C251.379 166.36 249.629 168.11 247.469 168.11C245.309 168.11 243.559 166.36 243.559 164.2C243.559 162.04 245.309 160.29 247.469 160.29C249.629 160.29 251.379 162.04 251.379 164.2Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.727 181.76C250.727 183.56 249.268 185.03 247.458 185.03C245.648 185.03 244.188 183.57 244.188 181.76C244.188 179.95 245.648 178.49 247.458 178.49C249.268 178.49 250.727 179.95 250.727 181.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.416 181.78C249.416 182.86 248.546 183.73 247.466 183.73C246.386 183.73 245.516 182.86 245.516 181.78C245.516 180.7 246.386 179.83 247.466 179.83C248.546 179.83 249.416 180.7 249.416 181.78Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.967 168.11H246.957V179.83H247.967V168.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M261.869 191.06H234.609V218.32H261.869V191.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.126 206.49C250.126 207.38 249.406 208.1 248.516 208.1C247.626 208.1 246.906 207.38 246.906 206.49C246.906 205.6 247.626 204.88 248.516 204.88C249.406 204.88 250.126 205.6 250.126 206.49Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.515 204.89C248.355 201 257.725 192.9 251.475 192.9C245.225 192.9 241.145 197.3 241.385 199.87C241.625 202.44 248.515 204.89 248.515 204.89Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.537 208.23C244.797 209.3 234.727 202.08 236.187 208.16C237.647 214.23 242.887 217.17 245.327 216.34C247.767 215.51 248.537 208.23 248.537 208.23Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.256 205.64C253.436 207.89 254.126 220.25 257.936 215.31C261.756 210.36 260.766 204.44 258.576 203.06C256.396 201.68 250.246 205.64 250.246 205.64H250.256Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.697 103.62C256.777 100.3 261.957 100.11 265.277 103.19C265.367 103.28 265.467 103.37 265.557 103.46C267.067 104.98 269.437 102.64 267.917 101.1C263.427 96.5602 256.107 96.5302 251.567 101.02C251.497 101.09 251.427 101.17 251.347 101.24C249.867 102.79 252.207 105.16 253.707 103.6V103.62H253.697Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.649 89.8502C248.149 85.9602 253.519 83.5202 259.529 83.5002C265.519 83.4302 271.309 85.6502 275.729 89.7002C277.289 91.1602 279.659 88.8302 278.089 87.3402C273.049 82.6802 266.429 80.1202 259.559 80.1802C252.639 80.1802 246.489 83.0102 241.319 87.4902C239.699 88.9102 242.049 91.2702 243.679 89.8502H243.639H243.649Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.607 97.4801C253.607 90.7901 263.897 90.23 270.587 96.24C270.907 96.53 271.217 96.83 271.517 97.14C273.017 98.68 275.377 96.33 273.877 94.78C266.397 86.96 253.997 86.6901 246.177 94.1601C245.857 94.4601 245.557 94.77 245.257 95.1C243.807 96.67 246.147 99.04 247.617 97.46V97.4801H247.607Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.349 355.47L175.339 352.8L172.619 331.56L161.559 335.49L166.349 355.47Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.32 329.57L171.99 325.23L173.74 340.51L163.38 343.41L160.32 329.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11 351.27L165.87 354.05C165.51 354.13 165.27 354.54 165.34 354.97L166.89 364.73C167.12 365.78 168.01 366.44 168.9 366.21C172.45 365.17 174.11 364.47 178.61 363.25C181.38 362.5 187.72 360.7 191.6 359.98C195.48 359.27 194.69 354.73 192.99 354.61C185.32 354.14 180.92 353.21 177.83 351.51C177.29 351.21 176.69 351.12 176.11 351.26V351.27Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.508 351.85C182.728 351.46 182.718 350.99 182.498 350.61C182.388 350.35 182.138 350.16 181.858 350.13C180.648 349.97 178.468 352.34 178.228 352.62C178.188 352.7 178.198 352.78 178.248 352.85C178.278 352.93 178.358 352.98 178.438 352.97C179.268 352.97 180.088 352.89 180.898 352.72C181.528 352.63 182.098 352.32 182.508 351.84V351.85ZM181.758 350.56C181.898 350.58 182.008 350.68 182.058 350.81C182.218 351.04 182.238 351.35 182.118 351.6C181.798 352.13 180.598 352.41 178.888 352.53C179.788 351.6 181.128 350.46 181.758 350.56Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53 352.92C179.31 352.16 180.22 349.93 179.77 348.98C179.61 348.63 179.22 348.44 178.85 348.52C178.5 348.54 178.19 348.74 178.02 349.04C177.3 350.14 178.17 352.72 178.17 352.84C178.2 352.91 178.26 352.97 178.33 352.99C178.37 352.99 178.43 352.99 178.43 352.99C178.47 352.99 178.51 352.97 178.54 352.93L178.53 352.92ZM178.89 348.95C179.21 348.92 179.36 349.04 179.36 349.16C179.47 350.29 179.15 351.41 178.46 352.31C178.1 351.33 178.07 350.27 178.36 349.27C178.45 349.12 178.6 349.01 178.77 348.97L178.88 348.95H178.89Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.802 240.35C120.802 240.35 174.042 244.84 172.742 267.96C171.672 286.89 168.862 281.74 174.382 338.02L160.992 338.76C160.992 338.76 147.362 292.73 149.202 274.44C134.192 274.44 99.8316 275.76 94.8416 262.22C92.3616 255.34 91.1616 248.07 91.2816 240.77L120.812 240.36L120.802 240.35Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.853 341.36L176.353 338.36L176.073 330.62L157.953 334.65L158.853 341.36Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.079 358.26L209.549 354.24L203.619 333.67L193.289 339.24L201.079 358.26Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.16 333.58L202.03 327.51L206.09 342.34L196.3 346.79L191.16 333.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.079 352.62L200.379 356.93C200.029 357.06 199.859 357.5 199.989 357.92L203.009 367.33C203.399 368.33 204.379 368.84 205.229 368.49C208.579 366.92 210.109 365.98 214.379 364.08C217.009 362.92 222.989 360.17 226.719 358.87C230.449 357.58 228.969 353.21 227.269 353.35C219.619 354.05 215.119 353.81 211.819 352.6C211.239 352.38 210.629 352.39 210.089 352.62H210.079Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.491 352.21C216.651 351.8 216.571 351.33 216.291 350.99C216.141 350.75 215.871 350.6 215.581 350.62C214.361 350.64 212.571 353.32 212.371 353.63C212.351 353.71 212.371 353.8 212.421 353.86C212.461 353.93 212.551 353.97 212.631 353.95C213.451 353.83 214.251 353.62 215.031 353.33C215.641 353.15 216.161 352.75 216.491 352.21ZM215.551 351.05C215.691 351.05 215.821 351.13 215.891 351.25C216.081 351.46 216.151 351.75 216.071 352.02C215.831 352.59 214.691 353.05 213.021 353.43C213.771 352.37 214.911 351.05 215.561 351.04L215.551 351.05Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72 353.88C213.37 353.01 213.93 350.66 213.34 349.8C213.12 349.48 212.72 349.35 212.36 349.49C212.02 349.57 211.74 349.81 211.62 350.13C211.08 351.33 212.33 353.75 212.35 353.86C212.39 353.93 212.45 353.97 212.53 353.98C212.57 353.98 212.63 353.96 212.63 353.96C212.67 353.95 212.71 353.92 212.73 353.89L212.72 353.88ZM212.47 349.9C212.78 349.82 212.94 349.92 212.97 350.04C213.25 351.13 213.11 352.3 212.57 353.29C212.07 352.38 211.87 351.33 212.01 350.3C212.08 350.14 212.21 350.01 212.37 349.94L212.48 349.9H212.47Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.648 240.35C136.998 240.35 196.338 246.46 196.408 266.58C196.538 299.87 206.038 338.02 206.038 338.02L194.308 343.83C194.308 343.83 173.888 302.47 174.198 276.52C157.878 271.84 115.648 279.71 110.648 266.18C106.558 255.11 108.768 240.35 108.768 240.35H136.638H136.648Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.436 345.52L208.156 338.45L206.896 332.01L190.316 337.74L192.436 345.52Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.239 169.32C108.509 172.59 107.059 175.75 105.609 179.04C104.159 182.33 102.849 185.62 101.629 189.01C100.409 192.39 99.3189 195.87 98.3989 199.48C97.4089 203.23 96.8189 207.08 96.6289 210.95C96.5289 213.23 96.7489 215.5 97.2989 217.72C97.6389 219.08 98.1789 220.38 98.8789 221.59C99.2889 222.28 99.7689 222.92 100.299 223.51L100.729 223.98C100.969 224.21 101.239 224.45 101.489 224.65C101.919 224.98 102.379 225.27 102.869 225.51C103.589 225.87 104.339 226.16 105.119 226.36C105.729 226.52 106.359 226.65 106.979 226.73C108.049 226.85 109.129 226.91 110.219 226.89C112.139 226.89 114.059 226.78 115.959 226.54C123.069 225.62 130.059 223.99 136.849 221.69L135.609 215.77C128.829 216.23 121.919 216.75 115.419 216.71C113.809 216.63 112.229 216.62 110.769 216.47C110.119 216.4 109.479 216.29 108.839 216.13C108.309 216.01 107.869 215.79 108.029 215.81C108.129 215.85 108.229 215.91 108.319 215.97C108.419 216.04 108.519 216.12 108.609 216.21C108.609 216.21 108.559 216.12 108.519 216.02C108.399 215.71 108.309 215.39 108.249 215.06C108.069 213.88 108.039 212.69 108.139 211.5C108.449 208.47 109.049 205.48 109.939 202.56C110.819 199.41 111.909 196.36 113.089 193.27C114.269 190.17 115.529 187.08 116.899 184C118.269 180.92 119.699 177.84 121.099 174.94L110.229 169.33L110.239 169.32Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.609 217.19L139.839 213.59L142.989 221.39C142.989 221.39 134.599 224.4 132.979 222.17L132.619 217.2L132.609 217.19Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46 215.321L148.42 220.571L142.99 221.331L139.84 213.541L145.46 215.321Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.738 182.5C133.088 185.89 131.608 182.05 133.088 185.33C134.578 188.61 136.058 191.84 137.638 195.07C140.798 201.64 144.348 208.03 148.258 214.19C149.318 215.76 150.378 217.32 151.568 218.88C152.158 219.67 152.818 220.44 153.518 221.24C153.898 221.64 154.208 222.02 154.658 222.43L155.298 223.05L155.658 223.39C156.668 224.26 157.858 224.89 159.138 225.24C159.818 225.43 160.498 225.58 161.198 225.68C162.328 225.82 163.478 225.86 164.618 225.82C166.588 225.76 168.558 225.56 170.498 225.24C177.698 223.97 184.748 221.97 191.548 219.27L191.608 211.8C184.738 212.63 177.718 213.51 171.108 213.79C169.548 213.85 167.988 213.83 166.438 213.73C165.808 213.68 165.188 213.58 164.578 213.43C164.378 213.38 164.188 213.31 164.008 213.22C163.948 213.22 164.008 213.15 164.298 213.33C164.398 213.39 164.498 213.46 164.588 213.54C164.588 213.54 164.518 213.44 164.478 213.41L164.178 213.08C163.988 212.89 163.758 212.57 163.528 212.32C163.088 211.77 162.648 211.17 162.198 210.53C161.318 209.27 160.458 207.86 159.608 206.44C157.908 203.59 156.328 200.57 154.778 197.51C153.228 194.45 151.738 191.33 150.278 188.18C147.358 181.91 147.398 182.57 144.678 176.25L131.738 182.53V182.5Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16 212.83L196.79 210.82L200.57 221.26C200.57 221.26 189.46 222.37 187.41 219.35L187.16 212.82V212.83Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.109 213.46L207.769 220.53L200.569 221.26L196.789 210.82L204.109 213.46Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53 139.96C137.12 142.07 137.98 144.1 139.11 145.98C137.85 146.91 135.93 146.16 135.93 146.16L136.53 139.96Z",
    fill: "#A02724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19 145.77C136.95 145.85 136.69 145.89 136.44 145.9C134.57 145.94 133 143.97 132.95 141.51C132.9 139.05 134.38 137.02 136.25 136.98C137.2 136.96 138.09 137.43 138.75 138.32C139.36 139.14 139.72 140.22 139.74 141.37C139.79 143.44 138.71 145.29 137.19 145.78V145.77ZM135.65 137.57C134.35 137.98 133.41 139.59 133.45 141.49C133.5 143.67 134.83 145.42 136.43 145.39C136.63 145.39 136.84 145.35 137.04 145.29C138.36 144.87 139.28 143.22 139.24 141.37C139.22 140.32 138.9 139.34 138.35 138.61C137.79 137.86 137.04 137.46 136.26 137.47C136.05 137.47 135.85 137.51 135.65 137.57Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19 146.34L117.43 151.81L124.58 159.26C123.99 160.12 123.57 161.09 123.33 162.11C122.69 164.34 122.15 165.98 126.99 168.15C128.05 168.58 128.76 169.59 128.8 170.73C128.8 172.11 127.72 173.6 122.92 173.69C118.29 173.67 113.79 172.17 110.07 169.41C108.24 168.12 108.43 166.93 109.57 165.05C112.94 159.72 112.86 152.25 112.19 146.34Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23 139.6C138.29 140.34 138.02 140.96 137.64 140.99C137.26 141.02 136.9 140.45 136.84 139.71C136.78 138.97 137.05 138.35 137.43 138.32C137.81 138.29 138.17 138.86 138.23 139.6Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59 149.56C135.44 153.77 132.4 156.92 128.78 158.4C127.49 158.93 126.13 159.25 124.74 159.32C121.55 159.49 118.29 158.37 115.7 155.64C111.15 150.82 111.45 145.37 111.15 136.1C111.08 134.22 111.41 132.35 112.13 130.61C114.88 124.04 122.42 120.93 129 123.67C137.96 127.47 138.82 141.25 136.58 149.56H136.59Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.77 158.41C127.48 158.94 126.12 159.26 124.73 159.33L124.57 159.26L125.45 157.54C125.45 157.54 125.99 159.01 128.76 158.41H128.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36 136.447L126.227 136.929L140.033 140.765L140.167 140.284L126.36 136.447Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.039 141.93C127.409 144.67 125.429 147.35 124.989 150.5C124.799 151.82 114.739 153.79 112.329 151.27C109.909 148.75 108.449 145.45 107.459 142.1C106.249 137.98 105.699 133.54 106.789 129.38C107.419 126.97 108.659 124.64 110.649 123.15C112.639 121.66 115.459 121.14 117.679 122.28C122.279 119.27 128.599 119.14 133.319 121.96C138.039 124.78 140.909 130.41 140.429 135.89C140.399 136.21 140.349 136.55 140.119 136.77C139.829 137.05 139.369 137.02 138.969 136.97C137.059 136.74 135.149 136.51 133.249 136.28C132.529 136.19 131.649 135.96 131.519 135.25C131.439 134.8 130.959 132.47 130.939 132.13L129.059 141.93H129.039Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.731 141.04C123.151 143.09 124.321 144.9 126.001 146.14C128.171 147.71 130.361 145.48 130.341 142.85C130.321 140.49 128.771 137.22 126.301 136.7C123.841 136.18 122.221 138.51 122.731 141.04Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.777 118.25C116.057 118.14 117.297 119.06 117.757 120.25C118.037 120.97 118.307 122.69 117.507 123.06C116.617 121.4 116.017 119.73 114.777 118.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5999 169.36C95.3999 167.24 99.1099 165.11 101.4 165.11H102.91C105.54 165.11 108.83 165.32 112.01 165.69C118.08 166.36 124.11 167.38 130.07 168.73C132.81 169.45 135.45 170.37 137.56 171.15C140.24 172.21 141.81 172.92 141.81 172.92C141.81 172.92 138.88 192.45 137.36 211.84C136.52 222.63 136.87 233.35 136.6 240.72H91.2899C89.7299 231.86 89.9699 224.14 89.8499 208.14C89.7799 198.54 91.3399 178.09 94.6199 169.35L94.5999 169.36Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.33 201.01C137.99 205.08 137.64 209.35 137.27 213.62C131.96 205.87 129.02 184.66 129.02 184.66L138.33 201.02V201.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.358 174.36C150.848 178.01 157.208 196.71 157.208 196.71L142.348 207.92C136.678 202.56 128.378 189.25 127.478 183.93C126.018 175.76 133.958 168.54 144.358 174.36Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.18 373.68C157.18 376.23 159.25 378.3 161.8 378.3C164.35 378.3 166.42 376.23 166.42 373.68C166.42 371.13 164.35 369.06 161.8 369.06C159.25 369.06 157.18 371.13 157.18 373.68Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2595 373.68C88.2595 376.23 86.1895 378.3 83.6395 378.3C81.0895 378.3 79.0195 376.23 79.0195 373.68C79.0195 371.13 81.0895 369.06 83.6395 369.06C86.1895 369.06 88.2595 371.13 88.2595 373.68Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.22 372.21C127.22 374.76 125.15 376.83 122.6 376.83C120.05 376.83 117.98 374.76 117.98 372.21C117.98 369.66 120.05 367.59 122.6 367.59C125.15 367.59 127.22 369.66 127.22 372.21Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.041 366.5V357.57H137.271C139.871 357.57 142.461 357.81 145.011 358.29L169.651 363.08C170.871 363.32 171.661 364.49 171.421 365.71C171.211 366.79 170.251 367.56 169.151 367.52L124.031 366.5H124.041Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.041 366.5V357.57H110.801C108.201 357.57 105.611 357.81 103.061 358.29L75.3712 362.72C74.1612 362.96 73.3612 364.13 73.6012 365.35C73.8112 366.43 74.7712 367.2 75.8712 367.16L124.051 366.5H124.041Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.242 313.11H115.852V360.28H132.242V313.11Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.871 283.22H118.191V313.34H129.871V283.22Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.881 288.81L118.191 291.75V283.22H129.881V288.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.741 240.19H161.801V265.52H167.741V240.19Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M167.741 240.19H161.801V265.52H167.741V240.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.042 283.22V173.1C132.042 168.93 130.242 164.96 127.102 162.22L119.252 155.35C116.612 153.04 113.232 151.77 109.722 151.77H81.3717L67.5117 166.51V283.22H132.032H132.042Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25 261.92H109.57V283.23H184.79C189.01 283.23 192.44 279.81 192.44 275.59C192.44 274.22 192.07 272.87 191.37 271.69C187.79 265.64 181.28 261.93 174.25 261.93V261.92Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M67.5117 166.52V283.23H184.792C189.012 283.23 192.442 279.81 192.442 275.58C192.442 274.21 192.082 272.86 191.382 271.68C187.802 265.64 181.312 261.92 174.292 261.92H141.712C136.372 261.92 132.042 257.59 132.042 252.25V173.1C132.042 168.94 130.252 164.96 127.102 162.22L119.252 155.35C116.622 153.03 113.232 151.77 109.722 151.77H81.3717L67.5117 166.51V166.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6 283.22V173.1C122.6 168.93 120.8 164.96 117.66 162.22L109.81 155.35C107.17 153.04 103.79 151.77 100.28 151.77H78.1803C74.1903 151.77 70.3703 153.42 67.6403 156.33L61.9903 162.34C59.4703 165.02 58.0703 168.56 58.0703 172.25V272.21C58.0703 278.3 63.0103 283.24 69.1003 283.24H122.6V283.22Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.6 283.22V173.1C122.6 168.93 120.8 164.96 117.66 162.22L109.81 155.35C107.17 153.04 103.79 151.77 100.28 151.77H78.1803C74.1903 151.77 70.3703 153.42 67.6403 156.33L61.9903 162.34C59.4703 165.02 58.0703 168.56 58.0703 172.25V272.21C58.0703 278.3 63.0103 283.24 69.1003 283.24H122.6V283.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.61 247.92C157.68 243.36 171.9 243.36 184.97 247.92C187.68 248.94 190.73 247.78 192.08 245.21C193.29 242.65 191.67 239.34 188.37 238.18C173.11 232.85 156.49 232.85 141.23 238.18C137.94 239.33 136.31 242.65 137.52 245.21C138.87 247.76 141.9 248.92 144.6 247.92H144.61Z",
    fill: "#5B4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M144.61 247.92C157.68 243.36 171.9 243.36 184.97 247.92C187.68 248.94 190.73 247.78 192.08 245.21C193.29 242.65 191.67 239.34 188.37 238.18C173.11 232.85 156.49 232.85 141.23 238.18C137.94 239.33 136.31 242.65 137.52 245.21C138.87 247.76 141.9 248.92 144.6 247.92H144.61Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3943_50181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 382.61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgConnectLogin);
export default __webpack_public_path__ + "static/media/gg-connect-login.fb7d6ace5543377c3930767fc520ad86.svg";
export { ForwardRef as ReactComponent };